import React, { useState } from "react";
import ReactPlayer from "react-player";
import classnames from "classnames";
import styles from "./VideoEmbed.module.scss";

export type Type =
  | "default"
  | "halfWidth"
  | "hero"
  | "heroTwoCol"
  | "billboard";

type Props = {
  videoUrl: string;
  accessibilityLabel: string;
  className?: string;
  isInline?: boolean;
  fallback?: string;
  type?: Type;
};

const VideoEmbed = ({
  videoUrl,
  accessibilityLabel,
  className,
  isInline,
  fallback,
  type = "default"
}: Props) => {
  const [isLoading, setLoading] = useState<boolean>(true);

  const isHero =
    type === "hero" ||
    type === "billboard" ||
    type === "halfWidth" ||
    type === "heroTwoCol";

  const fallbackImage = () => {
    return (
      <img
        src={fallback}
        alt={`${type} video`}
        className={classnames(styles["videoPreview"])}
      />
    );
  };

  return (
    <div className={classnames(styles["VideoEmbed"], className)}>
      <div
        className={classnames(
          styles["playerWrapper"],
          styles[`playerWrapper--${type}`]
        )}
      >
        <ReactPlayer
          width={isHero ? null : "560"}
          height={isHero ? null : "315"}
          className={classnames(styles["player"])}
          url={videoUrl}
          controls={!isHero}
          loop={isHero}
          muted={isHero}
          playing={isHero}
          playsinline={isInline || isHero}
          config={{
            youtube: {
              playerVars: {
                controls: isHero ? 0 : 1,
                showinfo: 1
              },
              embedOptions: { title: accessibilityLabel } //  appends label to iFrame title attribute
            },
            vimeo: {
              playerOptions: {
                controls: !isHero,
                background: isHero,
                loop: isHero
              }
            }
          }}
          onPlay={() => setLoading(false)}
        ></ReactPlayer>
        {isHero &&
          type !== "heroTwoCol" &&
          isLoading &&
          fallback &&
          fallbackImage()}
      </div>
    </div>
  );
};

export default VideoEmbed;
